export const INCREMENT_BUNDLE = "INCREMENT_BUNDLE";
export const DECREMENT_BUNDLE = "DECREMENT_BUNDLE";
export const SET_BUNDLE = "SET_BUNDLE";
export const SET_NEW_BUNDLE_QUANTITIES = "SET_NEW_BUNDLE_QUANTITIES";
export const CLEAR_SELECTED_BUNDLES = "CLEAR_SELECTED_BUNDLES";

export const SET_BUNDLE_PRODUCT_CONFIG = "SET_BUNDLE_PRODUCT_CONFIG";

export function incrementBundle(id) {
    return {type: INCREMENT_BUNDLE, id}
}

export function decrementBundle(id) {
    return {type: DECREMENT_BUNDLE, id}
}

export function setBundle(id, value) {
    return {type: SET_BUNDLE, id, value}
}

export function setBundleProductConfig(configuration) {
    return {type: SET_BUNDLE_PRODUCT_CONFIG, configuration}
}

export function setBundlesQuantities(quantities) {
    return {type: SET_NEW_BUNDLE_QUANTITIES, quantities};
}

export function clearSelectedBundles() {
    return {type: CLEAR_SELECTED_BUNDLES};
}